export default __webpack_public_path__ + "static/media/contract_1.55d0614a.jpg";